// Simplified Sector Icons Mapping for JFS Mutual Funds

// Import statements for all sector icons
import abrasivesIcon from '../../../Assets/JFS/assets/sectors/abrasives.svg';
import agriIcon from '../../../Assets/JFS/assets/sectors/agri.svg';
import alcoholIcon from '../../../Assets/JFS/assets/sectors/alcohol.svg';
import automobileAndAncillariesIcon from '../../../Assets/JFS/assets/sectors/automobile_and_ancillaries.svg';
import aviationIcon from '../../../Assets/JFS/assets/sectors/aviation.svg';
import bankIcon from '../../../Assets/JFS/assets/sectors/bank.svg';
import capitalGoodsIcon from '../../../Assets/JFS/assets/sectors/capital_goods.svg';
import chemicalsIcon from '../../../Assets/JFS/assets/sectors/chemicals.svg';
import constructionMaterialsIcon from '../../../Assets/JFS/assets/sectors/construction_materials.svg';
import consumerDurablesIcon from '../../../Assets/JFS/assets/sectors/consumer_durables.svg';
import consumerTechnologyIcon from '../../../Assets/JFS/assets/sectors/consumer_technology.svg';
import crudeOilIcon from '../../../Assets/JFS/assets/sectors/crude_oil.svg';
import diamondAndJewelleryIcon from '../../../Assets/JFS/assets/sectors/diamond_and_jewellery.svg';
import diversifiedIcon from '../../../Assets/JFS/assets/sectors/diversified.svg';
import educationAndTrainingIcon from '../../../Assets/JFS/assets/sectors/education_and_training.svg';
import electricalsIcon from '../../../Assets/JFS/assets/sectors/electricals.svg';
import etfRatingsIcon from '../../../Assets/JFS/assets/sectors/etf_ratings.svg';
import ferroManganeseIcon from '../../../Assets/JFS/assets/sectors/ferro_manganese.svg';
import financeIcon from '../../../Assets/JFS/assets/sectors/finance.svg';
import financialsIcon from '../../../Assets/JFS/assets/sectors/financials.svg';
import gasTransmissionIcon from '../../../Assets/JFS/assets/sectors/gas_transmission.svg';
import gSecIcon from '../../../Assets/JFS/assets/sectors/g_sec.svg';
import healthcareIcon from '../../../Assets/JFS/assets/sectors/healthcare.svg';
import hospitalityIcon from '../../../Assets/JFS/assets/sectors/hospitality.svg';
import indsGasesAndFuelsIcon from '../../../Assets/JFS/assets/sectors/inds_gases_and_fuels.svg';
import informationTechnologyIcon from '../../../Assets/JFS/assets/sectors/information_technology_button.svg';
import infrastructureIcon from '../../../Assets/JFS/assets/sectors/infrastructure.svg';
import insuranceIcon from '../../../Assets/JFS/assets/sectors/insurance.svg';
import ironAndSteelIcon from '../../../Assets/JFS/assets/sectors/iron_and_steel.svg';
import itIcon from '../../../Assets/JFS/assets/sectors/it.svg';
import logisticsIcon from '../../../Assets/JFS/assets/sectors/logistics.svg';
import materialsIcon from '../../../Assets/JFS/assets/sectors/materials.svg';
import mediaAndEntertainmentIcon from '../../../Assets/JFS/assets/sectors/media_and_entertainment.svg';
import miningIcon from '../../../Assets/JFS/assets/sectors/mining.svg';
import miscellaneousIcon from '../../../Assets/JFS/assets/sectors/miscellaneous.svg';
import nonFerrousMetalsIcon from '../../../Assets/JFS/assets/sectors/non_ferrous_metals.svg';
import othersIcon from '../../../Assets/JFS/assets/sectors/others.svg';
import paperIcon from '../../../Assets/JFS/assets/sectors/paper.svg';
import photographicProductsIcon from '../../../Assets/JFS/assets/sectors/photographic_products.svg';
import businessServicesIcon from '../../../Assets/JFS/assets/sectors/buisness_services.svg';
import plasticProductsIcon from '../../../Assets/JFS/assets/sectors/plastic_products.svg';
import powerIcon from '../../../Assets/JFS/assets/sectors/power.svg';
import realtyIcon from '../../../Assets/JFS/assets/sectors/realty.svg';
import retailingIcon from '../../../Assets/JFS/assets/sectors/retailing.svg';
import shipBuildingIcon from '../../../Assets/JFS/assets/sectors/ship_building.svg';
import telecomIcon from '../../../Assets/JFS/assets/sectors/telecom.svg';
import textileIcon from '../../../Assets/JFS/assets/sectors/textile.svg';
import tradingIcon from '../../../Assets/JFS/assets/sectors/trading.svg';
import trepsIcon from '../../../Assets/JFS/assets/sectors/treps.svg';

// Map of sector icons
const SECTOR_ICON_MAP: { [key: string]: string } = {
  abrasives: abrasivesIcon,
  agri: agriIcon,
  alcohol: alcoholIcon,
  automobileAndAncillaries: automobileAndAncillariesIcon,
  aviation: aviationIcon,
  bank: bankIcon,
  capitalGoods: capitalGoodsIcon,
  chemicals: chemicalsIcon,
  constructionMaterials: constructionMaterialsIcon,
  consumerDurables: consumerDurablesIcon,
  consumerTechnology: consumerTechnologyIcon,
  crudeOil: crudeOilIcon,
  diamondAndJewellery: diamondAndJewelleryIcon,
  diversified: diversifiedIcon,
  educationAndTraining: educationAndTrainingIcon,
  electricals: electricalsIcon,
  etfRatings: etfRatingsIcon,
  ferroManganese: ferroManganeseIcon,
  finance: financeIcon,
  financials: financialsIcon,
  gasTransmission: gasTransmissionIcon,
  gSec: gSecIcon,
  healthcare: healthcareIcon,
  hospitality: hospitalityIcon,
  indsGasesAndFuels: indsGasesAndFuelsIcon,
  informationTechnology: informationTechnologyIcon,
  infrastructure: infrastructureIcon,
  insurance: insuranceIcon,
  ironAndSteel: ironAndSteelIcon,
  it: itIcon,
  logistics: logisticsIcon,
  materials: materialsIcon,
  mediaAndEntertainment: mediaAndEntertainmentIcon,
  mining: miningIcon,
  miscellaneous: miscellaneousIcon,
  nonFerrousMetals: nonFerrousMetalsIcon,
  others: othersIcon,
  paper: paperIcon,
  photographicProducts: photographicProductsIcon,
  businessServices: businessServicesIcon,
  plasticProducts: plasticProductsIcon,
  power: powerIcon,
  realty: realtyIcon,
  retailing: retailingIcon,
  shipBuilding: shipBuildingIcon,
  telecom: telecomIcon,
  textile: textileIcon,
  trading: tradingIcon,
  treps: trepsIcon,
};

// Sector name to icon key mapping
export const SectorIcons: { [key: string]: string } = {
  // Exact sector names mapping
  Abrasives: 'abrasives',
  Agri: 'agri',
  Agriculture: 'agri',
  Alcohol: 'alcohol',
  'Automobile & Ancillaries': 'automobileAndAncillaries',
  'Automobile and Ancillaries': 'automobileAndAncillaries',
  Aviation: 'aviation',
  Bank: 'bank',
  Banks: 'bank',
  Banking: 'bank',
  'Capital Goods': 'capitalGoods',
  Cement: 'others', // Icon removed, fallback to others
  Chemicals: 'chemicals',
  'Construction Materials': 'constructionMaterials',
  'Consumer Durables': 'consumerDurables',
  'Consumer Technology': 'consumerTechnology',
  'Crude Oil': 'crudeOil',
  'Diamond & Jewellery': 'diamondAndJewellery',
  'Diamond and Jewellery': 'diamondAndJewellery',
  Diversified: 'diversified',
  'Education & Training': 'educationAndTraining',
  'Education and Training': 'educationAndTraining',
  Electricals: 'electricals',
  'ETF Ratings': 'etfRatings',
  ETF: 'etfRatings',
  'Ferro Manganese': 'ferroManganese',
  Finance: 'finance',
  Financial: 'finance',
  Financials: 'financials',
  'Financial Services': 'financials',
  FMCG: 'others', // Icon removed, fallback to others
  'Gas Transmission': 'gasTransmission',
  'G-Sec': 'gSec',
  'Government Securities': 'gSec',
  Healthcare: 'healthcare',
  'Health Care': 'healthcare',
  Hospitality: 'hospitality',
  'Inds Gases & Fuels': 'indsGasesAndFuels',
  'Industrial Gases and Fuels': 'indsGasesAndFuels',
  'Information Technology': 'it',
  IT: 'it',
  Infrastructure: 'infrastructure',
  Insurance: 'insurance',
  'Iron & Steel': 'ironAndSteel',
  'Iron and Steel': 'ironAndSteel',
  Logistics: 'logistics',
  Materials: 'materials',
  'Media & Entertainment': 'mediaAndEntertainment',
  'Media and Entertainment': 'mediaAndEntertainment',
  Mining: 'mining',
  Miscellaneous: 'miscellaneous',
  'Non Ferrous Metals': 'nonFerrousMetals',
  'Non-Ferrous Metals': 'nonFerrousMetals',
  'Non Ferrous Metal': 'nonFerrousMetals',
  'Non-Ferrous Metal': 'nonFerrousMetals',
  'NonFerrous Metals': 'nonFerrousMetals',
  'Nonferrous Metals': 'nonFerrousMetals',
  'Non ferrous metals': 'nonFerrousMetals',
  'NON FERROUS METALS': 'nonFerrousMetals',
  Others: 'others',
  Other: 'others',
  Paper: 'paper',
  'Photographic Products': 'photographicProducts',
  Pharma: 'photographicProducts',
  Pharmaceuticals: 'photographicProducts',
  'Business Services': 'businessServices',
  'Plastic Products': 'plasticProducts',
  Power: 'power',
  Realty: 'realty',
  'Real Estate': 'realty',
  Retailing: 'retailing',
  Retail: 'retailing',
  'Ship Building': 'shipBuilding',
  Telecom: 'telecom',
  Telecommunication: 'telecom',
  Telecommunications: 'telecom',
  Textile: 'textile',
  Textiles: 'textile',
  Trading: 'trading',
  TREPS: 'treps',
  'T-REPS': 'treps',
};

const getIconKeyForSector = (sectorName: string): string => {
  const normalizedSector = sectorName.trim().toLowerCase();
  for (const key in SectorIcons) {
    if (key.toLowerCase() === normalizedSector) {
      return SectorIcons[key];
    }
  }

  return 'others';
};

export const getSectorIconPath = (sectorName: string): string => {
  const iconKey = getIconKeyForSector(sectorName);
  return SECTOR_ICON_MAP[iconKey] || othersIcon;
};

// Helper function to get sector icon (for backward compatibility)
export const getSectorIcon = getSectorIconPath;

// Helper function to generate initials from sector name
export const getSectorInitials = (sectorName: string): string => {
  const words = sectorName.trim().split(/\s+/);
  if (words.length === 1) {
    // Single word - take first two characters
    return words[0].substring(0, 2).toUpperCase();
  } else {
    // Multiple words - take first letter of first two words
    return words
      .slice(0, 2)
      .map((word) => word[0])
      .join('')
      .toUpperCase();
  }
};

// Sector color mapping - extracted from actual SVG files
// Each sector has a light background color and darker icon/text color
const SECTOR_COLORS: { [key: string]: { background: string; text: string } } = {
  // Financial sectors
  Finance: { background: '#FCF5ED', text: '#DF9F39' },
  Financial: { background: '#FCF5ED', text: '#DF9F39' },
  Financials: { background: '#FCF5ED', text: '#DF9F39' },
  'Financial Services': { background: '#FCF5ED', text: '#DF9F39' },
  Bank: { background: '#FCF5ED', text: '#DF9F39' },
  Banks: { background: '#FCF5ED', text: '#DF9F39' },
  Banking: { background: '#FCF5ED', text: '#DF9F39' },
  Insurance: { background: '#EEFDF9', text: '#1ECCB0' },
  Trading: { background: '#FCF5ED', text: '#DF9F39' },

  // Healthcare sectors
  Healthcare: { background: '#EEFDF9', text: '#1ECCB0' },
  'Health Care': { background: '#EEFDF9', text: '#1ECCB0' },
  Pharma: { background: '#FEF0ED', text: '#BC030E' },
  Pharmaceuticals: { background: '#FEF0ED', text: '#BC030E' },
  'Photographic Products': { background: '#FEF0ED', text: '#BC030E' },

  // Manufacturing and Industrial
  'Capital Goods': { background: '#F4F2FB', text: '#FA7D19' },
  Automobile: { background: '#FCEEEE', text: '#84002A' },
  'Automobile & Ancillaries': { background: '#FCEEEE', text: '#84002A' },
  'Automobile and Ancillaries': { background: '#FCEEEE', text: '#84002A' },
  Electricals: { background: '#FEF0ED', text: '#BC030E' },
  'Consumer Durables': { background: '#FEF0ED', text: '#BC030E' },
  'Iron & Steel': { background: '#EDFEF0', text: '#00A852' },
  'Iron and Steel': { background: '#EDFEF0', text: '#00A852' },
  'Non Ferrous Metals': { background: '#EDFEF0', text: '#00A852' },
  'Non-Ferrous Metals': { background: '#EDFEF0', text: '#00A852' },
  'Ferro Manganese': { background: '#EDFEF0', text: '#00A852' },

  // Technology
  IT: { background: '#F4F2FB', text: '#7529D9' },
  'Information Technology': { background: '#F4F2FB', text: '#7529D9' },
  'Consumer Technology': { background: '#FCEEEE', text: '#84002A' },

  // Consumer sectors
  FMCG: { background: '#F4F2FB', text: '#7529D9' },
  Retailing: { background: '#EDFEF0', text: '#00A852' },
  Retail: { background: '#EDFEF0', text: '#00A852' },
  'Food & Groceries': { background: '#FEF0ED', text: '#BC030E' },
  Alcohol: { background: '#FEF0ED', text: '#BC030E' },

  // Infrastructure and Construction
  Infrastructure: { background: '#F4F2FB', text: '#7529D9' },
  'Construction Materials': { background: '#F4F2FB', text: '#7529D9' },
  Materials: { background: '#FEF0ED', text: '#BC030E' },
  Cement: { background: '#F4F2FB', text: '#7529D9' },
  Realty: { background: '#FDEFF5', text: '#D9008D' },
  'Real Estate': { background: '#FDEFF5', text: '#D9008D' },

  // Energy and Resources
  Power: { background: '#EDFEF0', text: '#00A852' },
  'Oil & Gas': { background: '#EDFEF0', text: '#00A852' },
  'Crude Oil': { background: '#EDFEF0', text: '#00A852' },
  'Gas Transmission': { background: '#EDFEF0', text: '#00A852' },
  'Inds Gases & Fuels': { background: '#EDFEF0', text: '#00A852' },
  'Industrial Gases and Fuels': { background: '#EDFEF0', text: '#00A852' },
  Mining: { background: '#EDFEF0', text: '#00A852' },

  // Services and Others
  Telecom: { background: '#EDEFFD', text: '#1600A3' },
  Telecommunication: { background: '#EDEFFD', text: '#1600A3' },
  Telecommunications: { background: '#EDEFFD', text: '#1600A3' },
  'Business Services': { background: '#F4F2FB', text: '#7529D9' },
  'Media & Entertainment': { background: '#FDEFF5', text: '#D9008D' },
  'Media and Entertainment': { background: '#FDEFF5', text: '#D9008D' },
  Textile: { background: '#FEF0ED', text: '#BC030E' },
  Textiles: { background: '#FEF0ED', text: '#BC030E' },
  Logistics: { background: '#FCEEEE', text: '#84002A' },
  Hospitality: { background: '#FDEFF5', text: '#D9008D' },
  Aviation: { background: '#F4F2FB', text: '#7529D9' },
  Paper: { background: '#FEF0ED', text: '#BC030E' },
  'Plastic Products': { background: '#FEF0ED', text: '#BC030E' },
  'Ship Building': { background: '#FCEEEE', text: '#84002A' },
  Chemicals: { background: '#EDFEF0', text: '#00A852' },
  'Diamond & Jewellery': { background: '#FCF5ED', text: '#DF9F39' },
  'Diamond and Jewellery': { background: '#FCF5ED', text: '#DF9F39' },
  Diversified: { background: '#F4F2FB', text: '#7529D9' },
  'Education & Training': { background: '#F4F2FB', text: '#7529D9' },
  'Education and Training': { background: '#F4F2FB', text: '#7529D9' },
  ETF: { background: '#F4F2FB', text: '#7529D9' },
  'ETF Ratings': { background: '#F4F2FB', text: '#7529D9' },
  'G-Sec': { background: '#FCF5ED', text: '#DF9F39' },
  'Government Securities': { background: '#FCF5ED', text: '#DF9F39' },
  TREPS: { background: '#FCF5ED', text: '#DF9F39' },
  'T-REPS': { background: '#FCF5ED', text: '#DF9F39' },
  Miscellaneous: { background: '#F4F2FB', text: '#7529D9' },
  Others: { background: '#F4F2FB', text: '#7529D9' },
  Other: { background: '#F4F2FB', text: '#7529D9' },
};

export const getSectorInitialsColor = (
  sectorName: string
): { background: string; text: string } => {
  const normalizedSector = sectorName.trim().toLowerCase();

  for (const key in SECTOR_COLORS) {
    if (key.toLowerCase() === normalizedSector) {
      return SECTOR_COLORS[key];
    }
  }

  return { background: '#F4F2FB', text: '#7529D9' };
};

export { othersIcon as others };

export const getSectorBackgroundColor = (sectorName: string): string => {
  return getSectorInitialsColor(sectorName).background;
};

export const getSectorTextColor = (sectorName: string): string => {
  return getSectorInitialsColor(sectorName).text;
};
